<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.type === 'CREATE' && !scope.row.is_advance" size="small" type="success">Normál</el-tag>
      <el-tooltip
        v-if="scope.row.type === 'STORNO' && !scope.row.is_advance"
        effect="dark"
        :content="`Sztornózza a következőt: ${scope.row.cancelled_invoice_number}`"
        placement="right"
      >
        <el-tag v-if="scope.row.type === 'STORNO' && !scope.row.is_advance" size="small" type="danger">Sztornó</el-tag>
      </el-tooltip>
      <el-tooltip
        v-if="scope.row.type === 'MODIFY' && !scope.row.is_advance"
        effect="dark"
        :content="`Módosítja a következőt: ${scope.row.modified_invoice_number}`"
        placement="right"
      >
        <el-tag v-if="scope.row.type === 'MODIFY' && !scope.row.is_advance" size="small" type="warning">Módosító okirat</el-tag>
      </el-tooltip>
      <el-tag v-if="scope.row.is_advance" size="small" type="success">Előleg</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'category',
};
</script>
